<template>
<v-layout row wrap class='pt-3' >
  <!-- <v-flex xs12 >
    <v-alert v-if='!requests.list.loading || requests.list.status !== 200' type='warning' :value='true' >
      {{requests.list.status}}
      <v-btn @click='getIntegrations' >Reload</v-btn>
    </v-alert>
  </v-flex> -->
  <v-flex xs12 sm6 lg4
    v-for='integration in visibleIntegrations'
    :key='integration.title' >
    <v-card height='100%' class='mb-3' >
      <v-list three-line>
        <v-list-tile >
          <v-list-tile-action >
            <img class='mr-3' height='50' :src='integration.logo' />
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{integration.title}}
              <v-chip v-if="isInstalled(integration)" color='success' class='ml-3 v-chip--x-small' label dark small >
                Installed
              </v-chip>
            </v-list-tile-title>
            <v-list-tile-sub-title >
              <a :href='integration.serviceURL' target='_blank' style='text-decoration:none;' >
                <!-- {{integration.serviceURL}} -->
                Open {{integration.title}}
                <v-icon small >open_in_new</v-icon>
              </a>
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action >
            <v-btn v-if='integration.installPath' small
              :to='integration.installPath' color='primary' >
                Manage
                <!-- <v-icon>open_in_new</v-icon> -->
            </v-btn>
            <v-btn v-if='integration.installURL'
              :href='integration.installURL' color='primary' >
                {{integration.cta}}
                <!-- <v-icon>open_in_new</v-icon> -->
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card-text>
        <blockquote v-if='integration.tagline' class="blockquote" >{{integration.tagline}}</blockquote>
        <p v-if='integration.description' vhtml='integration.description' ></p>
        <ul v-if='integration.features'>
          <v-subheader class='ml-0 pl-0'>Features</v-subheader>
          <li v-for='(feature, index) in integration.features' :key='index' class='ml-4' >
            {{feature}}
          </li>
        </ul>
      </v-card-text>
      <v-card-actions v-if='integration.helpDocs && integration.helpDocs.length > 0' >
        <v-btn color='primary' class='ml-4' outline >Learn more
          <v-menu offset-y >
            <template v-slot:activator="{ on }">
            <v-btn v-on='on' slot='activator' small icon >
              <v-icon>expand_more</v-icon>
            </v-btn>
            </template>
            <v-list dense>
              <v-list-tile v-for='doc in integration.helpDocs' :key='doc.title' >
                <v-list-tile-content>
                  <v-list-tile-title>{{doc.title}}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action v-if='doc.video' >
                  <v-btn :href='doc.video' target='_blank' icon ><v-icon>videocam</v-icon></v-btn>
                </v-list-tile-action>
                <v-list-tile-action >
                  <v-btn :href='doc.link' target='_blank' icon ><v-icon>open_in_new</v-icon></v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</v-layout>
</template>
<script>
export default {
  name: 'IntegrationsList',
  data () {
    return {
      integrations: [],
      requests: {
        list: {
          resource: 'ag.integrations',
          extra: 'list'
        }
      }
    }
  },
  mounted () {
    this.getIntegrations()
  },
  methods: {
    isInstalled (integration) {
      if (this.installed) {
        return this.installed.find((item) => {
          return item.title === integration.title
        })
      }
      return false
    },
    getIntegrations () {
      this.$request('get', this.requests.list)
    }
  },
  computed: {
    visibleIntegrations () {
      let integrations = this.getObjectPath(this.requests.list, 'result', [])
      return integrations.filter((integration) => { return integration.visible })
    },
    installed () {
      let lookups = this.$store.getters.lookups
      return this.getObjectPath(lookups, 'integrations', [])
    }
  }
}
</script>



// WEBPACK FOOTER //
// IntegrationsList.vue?86ac8f8e